import { render } from "./FilterClients.vue?vue&type=template&id=a21472f2&scoped=true"
import script from "./FilterClients.vue?vue&type=script&lang=js"
export * from "./FilterClients.vue?vue&type=script&lang=js"

import "./FilterClients.vue?vue&type=style&index=0&id=a21472f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21472f2"]])

export default __exports__